var map = {
	"./RankIconColor.svg": 1979,
	"./add-gradient.svg": 1980,
	"./add-icon.svg": 1981,
	"./add.svg": 1982,
	"./alarm-icon.svg": 1983,
	"./arrow-breadcrumbs.svg": 1984,
	"./arrow-down.svg": 1985,
	"./arrow.svg": 1986,
	"./arrow_right.svg": 1987,
	"./auth.svg": 1988,
	"./badges-blue-icon.svg": 1989,
	"./badges-icon.svg": 1990,
	"./book-open.svg": 1991,
	"./calendar.svg": 1992,
	"./calendar2.svg": 1993,
	"./camera.svg": 1994,
	"./chat-dots.svg": 1995,
	"./check-completed.svg": 1996,
	"./check-in-circle-gradient.svg": 1997,
	"./check-in-dark.svg": 1998,
	"./checkbox-selected.svg": 1999,
	"./chevron-blue-badge.svg": 2000,
	"./close-catalog.svg": 2001,
	"./close-training.svg": 2002,
	"./close.svg": 2003,
	"./copy.svg": 2004,
	"./correct-answer.svg": 2005,
	"./correctAnswer.svg": 2006,
	"./correctAnswerWide.svg": 2007,
	"./course-icon.svg": 2008,
	"./cross.svg": 2009,
	"./decrease.svg": 2010,
	"./delete-danger.svg": 2011,
	"./delete.svg": 2012,
	"./download-icon.svg": 2013,
	"./dustbin-active.svg": 2014,
	"./dustbin.svg": 2015,
	"./email-in-circle-gradient.svg": 2016,
	"./email.svg": 2017,
	"./emoji.svg": 2018,
	"./error-warning-fill.svg": 2019,
	"./error.svg": 2020,
	"./export.svg": 2021,
	"./favorite.svg": 2022,
	"./featured.svg": 2023,
	"./film.svg": 2024,
	"./filter-icon.svg": 2025,
	"./flag-icon.svg": 2026,
	"./folder-language.svg": 2027,
	"./folder.svg": 2028,
	"./heart.svg": 2029,
	"./heart_full.svg": 2030,
	"./import.svg": 2031,
	"./incorrect-answer.svg": 2032,
	"./increase.svg": 2033,
	"./info-builder.svg": 2034,
	"./info-icon-sky.svg": 2035,
	"./info-icon.svg": 2036,
	"./info.svg": 2037,
	"./left-gray-arrow.svg": 2038,
	"./levels-icon.svg": 2039,
	"./loader.svg": 2040,
	"./logo/horizontal/blue_black.svg": 2041,
	"./logo/horizontal/blue_blue_white.svg": 2042,
	"./logo/horizontal/blue_white.svg": 2043,
	"./menu.svg": 2044,
	"./message.svg": 2045,
	"./minus-icon.svg": 2046,
	"./more.svg": 2047,
	"./new-arrival.svg": 2048,
	"./notification_icon.svg": 2049,
	"./options.svg": 2050,
	"./pdf-file.svg": 2051,
	"./pdf-white.svg": 2052,
	"./personalized.svg": 2053,
	"./play-button-blue.svg": 2054,
	"./play-button-content.svg": 2055,
	"./play-button-dark-circle.svg": 2056,
	"./play-button-white-circle-solid.svg": 2057,
	"./play-button-white-circle.svg": 2058,
	"./play-button.svg": 2059,
	"./play-content-completed.svg": 2060,
	"./plus-icon.svg": 2061,
	"./products/phishing.svg": 2062,
	"./products/teams.svg": 2063,
	"./products/training.svg": 2064,
	"./products/unify.svg": 2065,
	"./profile.svg": 2066,
	"./puzzle-dark.svg": 2067,
	"./puzzle-white.svg": 2068,
	"./puzzle.svg": 2069,
	"./question.svg": 2070,
	"./quiz-dark.svg": 2071,
	"./quiz-white.svg": 2072,
	"./rank-icon.svg": 2073,
	"./recurrence.svg": 2074,
	"./refresh.svg": 2075,
	"./remove.svg": 2076,
	"./reorder.svg": 2077,
	"./repeat.svg": 2078,
	"./right-blue-arrow.svg": 2079,
	"./round-add-dark.svg": 2080,
	"./schedule.svg": 2081,
	"./search-icon.svg": 2082,
	"./selector.svg": 2083,
	"./settings.svg": 2084,
	"./sidebar-menu/icon-risk.svg": 1223,
	"./sidebar-menu/icon-strategy.svg": 1224,
	"./sidebar-menu/icon-training.svg": 1225,
	"./skip-video-arrow.svg": 2085,
	"./slider-arrow.svg": 2086,
	"./star-icon.svg": 2087,
	"./stop-button-white-circle-solid.svg": 2088,
	"./success.svg": 2089,
	"./tag-loader.svg": 2090,
	"./text-block-white.svg": 2091,
	"./text-block.svg": 2092,
	"./trophy1.svg": 2093,
	"./trophy2.svg": 2094,
	"./trophy3.svg": 2095,
	"./video-catalog.svg": 2096,
	"./video.svg": 2097,
	"./video2.svg": 2098,
	"./warning.svg": 2099,
	"./wideCross.svg": 2100,
	"./zoom-out.svg": 2101
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1978;